import { useConfirm } from "./confirm";
import { supabase } from "./supabase";
import { useToast } from "./toast";

/**
 * サインアウトの一連(確認→実行→結果のトースト)。
 * 入口(下部ナビ・サイドバー・ヘッダーのメニュー)が違っても同じ流れを通す。
 */
export function useSignOut(): () => Promise<void> {
  const confirm = useConfirm();
  const toast = useToast();
  return async () => {
    const ok = await confirm({ message: "サインアウトしますか？", confirmLabel: "サインアウト" });
    if (!ok) return;
    const { error } = await supabase.auth.signOut();
    if (error) {
      // 詳細はユーザーに出さない。原因はコンソールで追う
      console.error("サインアウトに失敗", error);
      toast("サインアウトに失敗しました。", "error");
      return;
    }
    // 成功すると認証状態の監視がサインイン画面へ切り替える。トーストは画面をまたいで残る
    toast("サインアウトしました。");
  };
}
